export default __webpack_public_path__ + "static/media/MCS Jewells.png.d28a4cf7.png";